import { Axios } from 'axios'
import { http } from '@/repositories/http'
import { CorporationTypeType } from '@/views/corporation-info/types'

export type CorporationInfoData = {
  corporateName: string;
  location: string;
  medicalCorporationNumber: string
  prefectureNumber: string;
  corporationNumber: string;
  corporationType: CorporationTypeType;
}

export type FacilityInfoData = {
  facilityKey: string
  displayOrder: number
  hospitalClinicKbn: string
  prefectureCode: string
  hasBedOutpatientMgmtNumber: string
  bedOutpatientMgmtNumber: string
  hasMedicalInstitutionCode: string
  medicalInstitutionCode: string
  hospitalClinicName: string
  executiveCount: number | null
  staffCount: number | null
  prefecture: string
  municipality: string
  townArea: string
  secondaryMedicalArea: string
  taxAccountingMethod: string
  primarySpecialty1: string
  primarySpecialty2: string
  primarySpecialty3: string
  hasBedFunctionReport: string
  outputSetting: string
  bmnGroup: string
}

export type FacilityInfoUiItem = {
  item: FacilityInfoData
  isValid: boolean
}

interface CorporationInfoRepository {
  getCorporationInfo(): Promise<CorporationInfoData>
  saveCorporationInfo(data: CorporationInfoData): Promise<void>
  getFacilityInfo(): Promise<FacilityInfoData[]>
  saveFacilityInfo(data: FacilityInfoData[]): Promise<void>
}

class CorporationInfoRepositoryImpl implements CorporationInfoRepository {
  constructor (http: Axios) {
    this.http = http
    this.baseUrlCorporation = '/corporation-info'
    this.baseUrlFacility = '/facility-info'
  }

  private readonly http: Axios
  private readonly baseUrlCorporation: string
  private readonly baseUrlFacility: string

  async getCorporationInfo (): Promise<CorporationInfoData> {
    const { data } = await this.http.get(this.baseUrlCorporation)
    return data
  }

  async saveCorporationInfo (data: CorporationInfoData): Promise<void> {
    await this.http.post(this.baseUrlCorporation, data)
  }

  async getFacilityInfo (): Promise<FacilityInfoData[]> {
    const { data } = await this.http.get(this.baseUrlFacility)
    return data
  }

  async saveFacilityInfo (data: FacilityInfoData[]): Promise<void> {
    await this.http.post(this.baseUrlFacility, data)
  }
}

export const repository = new CorporationInfoRepositoryImpl(http)
